const PackageActionBar = ({
  activeSectionLabel,
  isSubmitting,
  isDisabled,
  noChangesToSave = false,
  isLastSection,
  lastSavedAt,
  onSave,
  onSkip,
  onClose,
  saveLabel: saveLabelProp,
  skipLabel = "Skip section",
  hideSaveButton = false,
  showSkipButton = false,
}) => {
  const formatTime = (date) => {
    if (!date) return null;
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const saveLabel =
    saveLabelProp ??
    (isLastSection ? "Save & Finish" : `Save ${activeSectionLabel}`);

  return (
    <div className="sticky bottom-0 z-30 border-t border-gray-200 bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex w-full items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <div className="min-w-0 flex-1">
          {lastSavedAt ? (
            <p className="text-xs text-gray-500">
              <span className="inline-flex items-center gap-1.5 text-emerald-700">
                <i className="fi fi-rr-check relative top-0.5 text-emerald-500"></i>
                Draft saved at {formatTime(lastSavedAt)}
              </span>
            </p>
          ) : noChangesToSave ? (
            <p className="text-xs text-gray-500">
              No changes in{" "}
              <span className="font-medium text-gray-700">
                {activeSectionLabel}
              </span>
            </p>
          ) : (
            <p className="text-xs text-gray-500">
              Editing:{" "}
              <span className="font-medium text-gray-700">
                {activeSectionLabel}
              </span>
            </p>
          )}
        </div>

        <div className="flex shrink-0 items-center gap-2">
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="hidden rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 sm:inline-flex"
            >
              Cancel
            </button>
          )}
          {showSkipButton && onSkip && (
            <button
              type="button"
              onClick={onSkip}
              disabled={isSubmitting || isDisabled}
              className={`inline-flex items-center justify-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition ${
                isSubmitting || isDisabled
                  ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400"
                  : "border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              <i className="fi fi-rr-angle-double-right relative top-0.5 text-xs"></i>
              {skipLabel}
            </button>
          )}
          {!hideSaveButton && (
          <button
            type="button"
            onClick={onSave}
            disabled={isSubmitting || isDisabled}
            className={`inline-flex min-w-[140px] items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-sm font-semibold shadow-sm transition ${
              isSubmitting || isDisabled
                ? "cursor-not-allowed bg-gray-100 text-gray-400"
                : "bg-primary text-white hover:bg-primary/90 hover:shadow-md"
            }`}
          >
            {isSubmitting ? (
              <>
                <svg
                  className="h-4 w-4 animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Saving...
              </>
            ) : (
              <>
                <i className="fi fi-rr-disk relative top-0.5 text-xs"></i>
                {saveLabel}
              </>
            )}
          </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PackageActionBar;
